// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1xMOu","footer":"ChangeClinic_footer__37HNP"};